/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { injectable } from 'inversify'
import { BaseJwtStorage } from './BaseJwtStorage'

/**
 * implementation of jwt storage which uses localstorage
 *
 * @export
 * @class LocalJwtStorage
 * @extends {BaseJwtStorage}
 */
@injectable()
export class LocalJwtStorage extends BaseJwtStorage {
	public readonly saveJwt = (sessionJwtStorageKey: string, sessionJwt: string): void => localStorage.setItem(sessionJwtStorageKey, sessionJwt)
}
